import AboutUsSvg from "../svg/AboutUsSvg";
import AdmisisionProcessDistanceLearningSvg from "../svg/navigation/admission/AdmisisionProcessDistanceLearningSvg";
import AdmissionProcessFullTimeSvg from "../svg/navigation/admission/AdmissionProcessFullTimeSvg";
import AdvancedTrainingBookSvg from "../svg/navigation/advanced-training/AdvancedTrainingBookSvg";
import EducationPersonalSvg from "../svg/navigation/education/EducationPersonalSvg";
import EducationRemotelySvg from "../svg/navigation/education/EducationRemotelySvg";
import AboutMhmbSvg from "../svg/navigation/main/AboutMhmbSvg";
import AdmissionSvg from "../svg/navigation/main/AdmissionSvg";
import AdvancedTrainingSvg from "../svg/navigation/main/AdvancedTrainingSvg";
import ContactSvg from "../svg/navigation/main/ContactSvg";
import EducationSvg from "../svg/navigation/main/EducationSvg";
import ProgramsSvg from "../svg/navigation/main/ProgramsSvg";
import SearchSvg from "../svg/navigation/main/SearchSvg";
import FacultyArchitectureEngineeringSvg from "../svg/navigation/programs/FacultyArchitectureEngineeringSvg";
import FacultyBusinessSvg from "../svg/navigation/programs/FacultyBusinessSvg";
import FacultyITSvg from "../svg/navigation/programs/FacultyITSvg";
import FacultyLawSvg from "../svg/navigation/programs/FacultyLawSvg";
import FacultyMedicineSvg from "../svg/navigation/programs/FacultyMedicineSvg";
import FacultySocialHumanitarianSvg from "../svg/navigation/programs/FacultySocialHumanitarianSvg";

export const navigationConst = {
  title: "Навигация МШМБ",
  data: [
    {
      id: "about-mhmb",
      text: "Про МШМБ",
      image: AboutMhmbSvg,
    },
    {
      id: "programs",
      text: "Программы",
      image: ProgramsSvg,
    },
    {
      id: "admission",
      text: "Поступление",
      image: AdmissionSvg,
    },
    {
      id: "education",
      text: "Обучение",
      image: EducationSvg,
    },
    {
      id: "advanced-training",
      text: "Повышение квалификации",
      image: AdvancedTrainingSvg,
    },
    {
      id: "contact",
      text: "Контакты",
      image: ContactSvg,
      link: "/contact",
    },
    {
      id: "search",
      text: "Поиск",
      image: SearchSvg,
      link: "/search",
    },
  ],
};

export const navigationDynamicConst = [
  {
    id: "about-mhmb",
    title: "Про МШМБ",
    data: [
      {
        id: "about-university",
        text: "Об университе",
        image: AboutUsSvg,
        link: "/single-page/about-university",
      },
      {
        id: "our-advantages",
        text: "Наши преимущества",
        image: AboutUsSvg,
        link: "/single-page/our-advantages",
      },
      {
        id: "campus",
        text: "Кампус",
        image: AboutUsSvg,
        link: "/single-page/campus",
      },
    ],
  },
  {
    id: "programs",
    title: "Программы",
    data: [
      {
        id: "programs-education-medical",
        text: "Факультет медицины",
        image: FacultyMedicineSvg,
        link: "/programs/education-medical",
      },
      {
        id: "programs-education-arch",
        text: "Архитектурно-инженерный факультет",
        image: FacultyArchitectureEngineeringSvg,
        link: "/programs/education-arch",
      },
      {
        id: "programs-education-business",
        text: "Факультет бизнеса",
        image: FacultyBusinessSvg,
        link: "/programs/education-business",
      },
      {
        id: "programs-education-technology",
        text: "Факультет IT",
        image: FacultyITSvg,
        link: "/programs/education-technology",
      },
      {
        id: "programs-education-sciences",
        text: "Факультет социально-гуманитарных наук",
        image: FacultySocialHumanitarianSvg,
        link: "/programs/education-sciences",
      },
      {
        id: "programs-education-law",
        text: "Факультет права",
        image: FacultyLawSvg,
        link: "/programs/education-law",
      },
    ],
  },
  {
    id: "admission",
    title: "Поступление",
    data: [
      {
        id: "admission-process-full-time",
        text: "Процесс поступления на очную форму",
        image: AdmissionProcessFullTimeSvg,
        link: "/single-page/admission-process-full-time",
      },
      {
        id: "admisision-process-distance-learning",
        text: "Процесс поступления на дистанционную форму",
        image: AdmisisionProcessDistanceLearningSvg,
        link: "/single-page/admisision-process-distance-learning",
      },
    ],
  },
  {
    id: "education",
    title: "Обучение",
    data: [
      {
        id: "education-personal",
        text: "Очное",
        image: EducationPersonalSvg,
        link: "/single-page/education-personal",
      },
      {
        id: "education-remotely",
        text: "Дистанционно (онлайн)",
        image: EducationRemotelySvg,
        link: "/single-page/education-remotely",
      },
    ],
  },
  {
    id: "advanced-training",
    title: "Повышение квалификации",
    data: [
      {
        id: "modern-pedagogical-technologies",
        text: "Современные педагогические технологии",
        image: AdvancedTrainingBookSvg,
        link: "/single-page/modern-pedagogical-technologies",
      },
      {
        id: "digitization-and-edtech",
        text: "Цифровизация и EdTech",
        image: AdvancedTrainingBookSvg,
        link: "/single-page/digitization-and-edtech",
      },
      {
        id: "international-cooperation-and-internationalization",
        text: "Международное сотрудничество и интернационализация",
        image: AdvancedTrainingBookSvg,
        link: "/single-page/international-cooperation-and-internationalization",
      },
      {
        id: "quality-and-academic-integrity",
        text: "Качество и академическая добросовестность",
        image: AdvancedTrainingBookSvg,
        link: "/single-page/quality-and-academic-integrity",
      },
      {
        id: "medicine-and-healthcare",
        text: "Медицина и здравоохранение",
        image: AdvancedTrainingBookSvg,
        link: "/single-page/medicine-and-healthcare",
      },
      {
        id: "soft-skills-and-resources-of-the-teachet",
        text: "Мягкие навыки и ресурсность преподавателя",
        image: AdvancedTrainingBookSvg,
        link: "/single-page/soft-skills-and-resources-of-the-teachet",
      },
      {
        id: "english-for-career-and-international-communication",
        text: "Английский для карьеры и международного общения",
        image: AdvancedTrainingBookSvg,
        link: "/single-page/english-for-career-and-international-communication",
      },
      {
        id: "innovation-and-project-thinking-in-higher-education",
        text: "Инновации и проектное мышление в высшем образовании",
        image: AdvancedTrainingBookSvg,
        link: "/single-page/innovation-and-project-thinking-in-higher-education",
      },
    ],
  },
];
